module.exports = __webpack_public_path__ + "img/5.d0f656be.jpg";